function initSetupSheets() {
  const studio = document.querySelector("[data-setup-studio]");
  if (!studio) {
    return;
  }

  const switcher = document.querySelector("[data-setup-switch]");
  const image = studio.querySelector("[data-setup-image]");
  const openPdf = studio.querySelector("[data-setup-open-pdf]");
  const title = studio.querySelector("[data-setup-title]");
  const category = studio.querySelector("[data-setup-category]");
  const copy = studio.querySelector("[data-setup-copy]");
  const noteLayer = studio.querySelector("[data-setup-note-layer]");
  const stage = studio.querySelector("[data-setup-stage]");
  const noteInput = studio.querySelector("[data-setup-note-input]");
  const placeButton = studio.querySelector("[data-setup-place]");
  const updateButton = studio.querySelector("[data-setup-update]");
  const deleteButton = studio.querySelector("[data-setup-delete]");
  const downloadButton = studio.querySelector("[data-setup-download]");
  const resetButton = studio.querySelector("[data-setup-reset]");
  const selectedState = studio.querySelector("[data-setup-selected-state]");
  const noteCount = studio.querySelector("[data-setup-note-count]");
  const currentProductState = studio.querySelector("[data-setup-current-product]");
  const noteList = studio.querySelector("[data-setup-note-list]");
  const downloadPdf = studio.querySelector("[data-setup-download-pdf]");
  const openGuide = studio.querySelector("[data-setup-open-guide]");
  const editorStatus = studio.querySelector("[data-setup-editor-status]");
  const exportPanel = studio.querySelector("[data-setup-export-panel]");
  const exportCopy = studio.querySelector("[data-setup-export-copy]");
  const exportOpen = studio.querySelector("[data-setup-export-open]");
  const exportPreview = studio.querySelector("[data-setup-export-preview]");
  let lastExportUrl = "";
  const inlineSheets = window.ZHSetupSheetPreviewData || {};

  const defaultSheets = {
    "1178": {
      title: "1178 Setup Sheet",
      category: "Studio Rack",
      image: inlineSheets["1178"] || "../assets/setup-sheets/1178-setup-sheet.jpg",
      pdf: "../assets/setup-sheets/1178-setup-sheet.pdf",
      guide: "../products/1178.html",
      copy: "Fast stereo limiter sessions usually need only a few precise notes around the official panel layout."
    },
    "vca": {
      title: "VCA Setup Sheet",
      category: "Studio Rack",
      image: inlineSheets["vca"] || "../assets/setup-sheets/vca-setup-sheet.jpg",
      pdf: "../assets/setup-sheets/vca-setup-sheet.pdf",
      guide: "../products/vca.html",
      copy: "Use the sheet itself for control positions, then annotate what the unit was doing in the chain."
    },
    "hvc250": {
      title: "HVC250 Setup Sheet",
      category: "Studio Rack",
      image: inlineSheets["hvc250"] || "../assets/setup-sheets/hvc250-setup-sheet.jpg",
      pdf: "../assets/setup-sheets/hvc250-setup-sheet.pdf",
      guide: "../products/hvc250.html",
      copy: "For EQ, short notes about source, broad intent, and revision context are often more useful than a generic form."
    },
    "hopto": {
      title: "HOPTO Setup Sheet",
      category: "Studio Rack",
      image: inlineSheets["hopto"] || "../assets/setup-sheets/hopto-setup-sheet.jpg",
      pdf: "../assets/setup-sheets/hopto-setup-sheet.pdf",
      guide: "../products/hopto.html",
      copy: "Optical sessions often benefit from quick notes about target movement and where the unit sat in the chain."
    },
    "me250x": {
      title: "ME-250X Setup Sheet",
      category: "Mastering",
      image: inlineSheets["me250x"] || "../assets/setup-sheets/me250x-setup-sheet.jpg",
      pdf: "../assets/setup-sheets/me250x-setup-sheet.pdf",
      guide: "../products/me-250dx.html",
      copy: "For mastering sheets, the blank layout plus a few revision notes is usually enough to preserve intent."
    },
    "v250": {
      title: "V250 Setup Sheet",
      category: "500 Series",
      image: inlineSheets["v250"] || "../assets/setup-sheets/v250-setup-sheet.jpg",
      pdf: "../assets/setup-sheets/v250-setup-sheet.pdf",
      guide: "../products/v250.html",
      copy: "The V250 sheet works best as a fast visual record with one or two notes for source and target tone."
    },
    "v560": {
      title: "V560 Setup Sheet",
      category: "500 Series",
      image: inlineSheets["v560"] || "../assets/setup-sheets/v560-setup-sheet.jpg",
      pdf: "../assets/setup-sheets/v560-setup-sheet.pdf",
      guide: "../products/v560.html",
      copy: "Graphic EQ recall is visual by nature, so the sheet stays primary and notes only add context."
    }
  };
  const sheets = window.ZHOwnerGuideSetupSheets || defaultSheets;

  const notesByProduct = {};
  const storageKey = "zh-owner-guide-setup-notes-v1";
  const aliases = {
    "1178": "1178",
    "vca": "vca",
    "hvc250": "hvc250",
    "hopto": "hopto",
    "me-250dx": "me250x",
    "me-250x": "me250x",
    "me250x": "me250x",
    "v250": "v250",
    "v560": "v560"
  };

  let currentProduct = "1178";
  let placingMode = false;
  let selectedNoteId = null;

  const setEditorStatus = (message) => {
    if (editorStatus) {
      editorStatus.textContent = message;
    }
  };

  const revokeLastExportUrl = () => {
    if (lastExportUrl && lastExportUrl.startsWith("blob:")) {
      URL.revokeObjectURL(lastExportUrl);
    }
    lastExportUrl = "";
  };

  const setExportState = (url, filename) => {
    revokeLastExportUrl();
    lastExportUrl = url;
    if (exportPanel) {
      exportPanel.hidden = false;
    }
    if (exportCopy) {
      exportCopy.textContent = `${filename} is ready. If the automatic download does not start, open it manually.`;
    }
    if (exportOpen) {
      exportOpen.hidden = false;
      exportOpen.href = url;
      exportOpen.setAttribute("download", filename);
    }
    if (exportPreview) {
      exportPreview.src = url;
    }
  };

  const syncUiState = () => {
    const notes = ensureProductNotes(currentProduct);
    const selectedNote = notes.find((item) => item.id === selectedNoteId);
    const hasDraft = Boolean((noteInput?.value || "").trim());

    if (placeButton) {
      placeButton.classList.toggle("is-armed", placingMode);
      placeButton.textContent = placingMode ? "Click Sheet To Place Note" : "Click On Sheet To Place";
      placeButton.disabled = !hasDraft && !placingMode;
    }

    if (updateButton) {
      updateButton.disabled = !selectedNote || !hasDraft;
    }

    if (deleteButton) {
      deleteButton.disabled = !selectedNote;
    }

    if (resetButton) {
      resetButton.disabled = !notes.length;
    }
  };

  const readStoredNotes = () => {
    try {
      const raw = window.localStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  };

  const persistNotes = () => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(notesByProduct));
    } catch (error) {
      // Ignore local storage failures.
    }
  };

  Object.assign(notesByProduct, readStoredNotes());

  const ensureProductNotes = (productKey) => {
    if (!notesByProduct[productKey]) {
      notesByProduct[productKey] = [];
    }
    return notesByProduct[productKey];
  };

  const renderNoteList = () => {
    if (!noteList) {
      return;
    }

    const notes = ensureProductNotes(currentProduct);
    if (!notes.length) {
      noteList.innerHTML = '<p class="sheet-note-empty">No notes on this sheet yet.</p>';
      return;
    }

    noteList.innerHTML = notes
      .map(
        (note, index) => `
          <button type="button" class="sheet-note-list-item${
            note.id === selectedNoteId ? " is-active" : ""
          }" data-note-list-id="${note.id}">
            <span>${index + 1}.</span>
            <strong>${note.text}</strong>
          </button>
        `
      )
      .join("");

    noteList.querySelectorAll("[data-note-list-id]").forEach((button) => {
      button.addEventListener("click", () => {
        const noteId = button.getAttribute("data-note-list-id");
        const note = ensureProductNotes(currentProduct).find((item) => item.id === noteId);
        selectedNoteId = noteId;
        if (noteInput && note) {
          noteInput.value = note.text;
        }
        setEditorStatus("Selected note loaded. Update the text or drag it on the sheet.");
        renderNotes();
      });
    });
  };

  const updateSelectedState = () => {
    const notes = ensureProductNotes(currentProduct);
    const note = notes.find((item) => item.id === selectedNoteId);

    if (!selectedState) {
      return;
    }

    if (!note) {
      selectedState.textContent = placingMode
        ? "Click on the sheet to place the next note."
        : "No note selected.";
    } else {
      selectedState.textContent = `Selected: ${note.text}`;
    }

    if (noteCount) {
      noteCount.textContent = `${notes.length} ${notes.length === 1 ? "note" : "notes"} on this sheet.`;
    }
  };

  const renderNotes = () => {
    const notes = ensureProductNotes(currentProduct);
    noteLayer.innerHTML = "";
    stage.classList.toggle("is-placing", placingMode);

    notes.forEach((note) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "sheet-note";
      if (note.id === selectedNoteId) {
        button.classList.add("is-active");
      }
      button.style.left = `${note.x * 100}%`;
      button.style.top = `${note.y * 100}%`;
      button.textContent = note.text;
      button.dataset.noteId = note.id;

      let dragState = null;

      button.addEventListener("pointerdown", (event) => {
        event.preventDefault();
        selectedNoteId = note.id;
        if (noteInput) {
          noteInput.value = note.text;
        }
        setEditorStatus("Selected note loaded. Drag to reposition or update the text.");
        updateSelectedState();
        renderNoteList();
        syncUiState();
        noteLayer.querySelectorAll(".sheet-note").forEach((node) => {
          node.classList.toggle("is-active", node.dataset.noteId === note.id);
        });

        dragState = {
          rect: stage.getBoundingClientRect()
        };

        button.setPointerCapture(event.pointerId);
      });

      button.addEventListener("pointermove", (event) => {
        if (!dragState) {
          return;
        }

        const nextX = (event.clientX - dragState.rect.left) / dragState.rect.width;
        const nextY = (event.clientY - dragState.rect.top) / dragState.rect.height;
        note.x = Math.min(0.98, Math.max(0.02, nextX));
        note.y = Math.min(0.98, Math.max(0.02, nextY));
        button.style.left = `${note.x * 100}%`;
        button.style.top = `${note.y * 100}%`;
      });

      button.addEventListener("pointerup", () => {
        dragState = null;
        persistNotes();
        setEditorStatus("Note moved. Download the PNG when the layout feels right.");
        renderNoteList();
        syncUiState();
      });

      button.addEventListener("click", () => {
        selectedNoteId = note.id;
        if (noteInput) {
          noteInput.value = note.text;
        }
        setEditorStatus("Selected note loaded. Drag to reposition or update the text.");
        updateSelectedState();
        renderNotes();
      });

      noteLayer.appendChild(button);
    });

    renderNoteList();
    updateSelectedState();
    syncUiState();
  };

  const applySheet = (productKey) => {
    const sheet = sheets[productKey];
    currentProduct = productKey;
    selectedNoteId = null;
    placingMode = false;

    if (title) title.textContent = sheet.title;
    if (category) category.textContent = sheet.category;
    if (copy) copy.textContent = sheet.copy;
    if (image) {
      image.src = sheet.image;
      image.alt = `${sheet.title} preview`;
    }
    if (openPdf) {
      openPdf.href = sheet.pdf;
    }
    if (downloadPdf) {
      downloadPdf.href = sheet.pdf;
    }
    if (openGuide) {
      openGuide.href = sheet.guide;
    }
    if (currentProductState) {
      currentProductState.textContent = sheet.title;
    }

    if (switcher) {
      switcher.querySelectorAll("[data-setup-product]").forEach((button) => {
        button.classList.toggle(
          "active",
          button.getAttribute("data-setup-product") === productKey
        );
      });
    }

    if (noteInput) {
      noteInput.value = "";
    }
    setEditorStatus("Enter a short note, then place it on the sheet.");
    if (exportPanel) {
      exportPanel.hidden = true;
    }
    if (exportCopy) {
      exportCopy.textContent = "No export generated yet.";
    }
    if (exportPreview) {
      exportPreview.removeAttribute("src");
    }
    if (exportOpen) {
      exportOpen.hidden = true;
      exportOpen.removeAttribute("href");
      exportOpen.removeAttribute("download");
    }
    window.history.replaceState({}, "", `?product=${productKey}`);
    renderNotes();
  };

  const addNote = (x, y) => {
    const text = (noteInput?.value || "").trim();
    if (!text) {
      return;
    }

    const notes = ensureProductNotes(currentProduct);
    const note = {
      id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
      text,
      x,
      y
    };

    notes.push(note);
    selectedNoteId = note.id;
    placingMode = false;
    persistNotes();
    setEditorStatus("Note placed. You can drag it, edit it, or download the annotated PNG.");
    renderNotes();
  };

  if (switcher) {
    switcher.querySelectorAll("[data-setup-product]").forEach((button) => {
      button.addEventListener("click", () => {
        applySheet(button.getAttribute("data-setup-product"));
      });
    });
  }

  if (placeButton) {
    placeButton.addEventListener("click", () => {
      const hasDraft = Boolean((noteInput?.value || "").trim());
      if (!hasDraft && !placingMode) {
        setEditorStatus("Enter note text first, then arm placement.");
        syncUiState();
        return;
      }
      placingMode = !placingMode;
      if (placingMode) {
        selectedNoteId = null;
        setEditorStatus("Placement is armed. Click anywhere on the sheet.");
      } else {
        setEditorStatus("Placement cancelled.");
      }
      updateSelectedState();
      renderNotes();
    });
  }

  if (updateButton) {
    updateButton.addEventListener("click", () => {
      const notes = ensureProductNotes(currentProduct);
      const note = notes.find((item) => item.id === selectedNoteId);
      const nextText = (noteInput?.value || "").trim();
      if (!note || !nextText) {
        return;
      }
      note.text = nextText;
      persistNotes();
      setEditorStatus("Selected note updated.");
      renderNotes();
    });
  }

  if (deleteButton) {
    deleteButton.addEventListener("click", () => {
      const notes = ensureProductNotes(currentProduct);
      notesByProduct[currentProduct] = notes.filter((item) => item.id !== selectedNoteId);
      selectedNoteId = null;
      persistNotes();
      setEditorStatus("Selected note deleted.");
      renderNotes();
    });
  }

  if (resetButton) {
    resetButton.addEventListener("click", () => {
      notesByProduct[currentProduct] = [];
      selectedNoteId = null;
      placingMode = false;
      if (noteInput) {
        noteInput.value = "";
      }
      persistNotes();
      setEditorStatus("All notes cleared for this sheet.");
      renderNotes();
    });
  }

  if (noteInput) {
    noteInput.addEventListener("input", () => {
      syncUiState();
    });
  }

  if (stage) {
    stage.addEventListener("click", (event) => {
      if (!placingMode) {
        if (event.target === image || event.target === noteLayer) {
          selectedNoteId = null;
          if (noteInput) {
            noteInput.value = "";
          }
          setEditorStatus("No note selected.");
          renderNotes();
        }
        return;
      }

      if (event.target && event.target.closest(".sheet-note")) {
        return;
      }

      const rect = stage.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width;
      const y = (event.clientY - rect.top) / rect.height;
      addNote(Math.min(0.98, Math.max(0.02, x)), Math.min(0.98, Math.max(0.02, y)));
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && placingMode) {
      placingMode = false;
      setEditorStatus("Placement cancelled.");
      renderNotes();
    }
  });

  if (downloadButton) {
    downloadButton.addEventListener("click", async () => {
      setEditorStatus("Generating annotated PNG...");
      if (exportPanel) {
        exportPanel.hidden = false;
      }
      if (exportCopy) {
        exportCopy.textContent = "Generating export preview...";
      }
      if (exportOpen) {
        exportOpen.hidden = true;
      }
      if (!image || !image.complete) {
        setEditorStatus("Sheet preview is still loading. Try again in a moment.");
        return;
      }

      const notes = ensureProductNotes(currentProduct);
      const draftText = (noteInput?.value || "").trim();
      const exportNotes = notes.length
        ? notes
        : draftText
          ? [{ text: draftText, x: 0.1, y: 0.1 }]
          : [];

      if (!exportNotes.length) {
        setEditorStatus("Add a note first, or type one before exporting.");
        syncUiState();
        return;
      }

      const canvas = document.createElement("canvas");
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        return;
      }

      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
      const placedButtons = Array.from(noteLayer.querySelectorAll(".sheet-note"));
      const imageRect = image.getBoundingClientRect();
      const scaleX = canvas.width / imageRect.width;
      const scaleY = canvas.height / imageRect.height;

      if (placedButtons.length) {
        placedButtons.forEach((button) => {
          const rect = button.getBoundingClientRect();
          const style = window.getComputedStyle(button);
          const x = (rect.left - imageRect.left) * scaleX;
          const y = (rect.top - imageRect.top) * scaleY;
          const width = rect.width * scaleX;
          const height = rect.height * scaleY;
          const paddingLeft = parseFloat(style.paddingLeft || "0") * scaleX;
          const paddingTop = parseFloat(style.paddingTop || "0") * scaleY;
          const borderWidth = Math.max(1, parseFloat(style.borderTopWidth || "1") * scaleX);
          const fontSize = Math.max(12, parseFloat(style.fontSize || "14") * scaleY);
          const fontWeight = style.fontWeight || "700";
          const fontFamily = style.fontFamily || "Cabin, sans-serif";

          ctx.fillStyle = style.backgroundColor || "rgba(10, 10, 10, 0.88)";
          ctx.fillRect(x, y, width, height);
          ctx.strokeStyle = style.borderTopColor || "#a51e24";
          ctx.lineWidth = borderWidth;
          ctx.strokeRect(x, y, width, height);
          ctx.fillStyle = style.color || "#f3f0ea";
          ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
          ctx.textBaseline = "top";
          ctx.fillText(button.textContent || "", x + paddingLeft, y + paddingTop);
        });
      } else {
        ctx.font = `700 ${Math.max(26, Math.round(canvas.width * 0.014))}px Cabin, sans-serif`;
        ctx.textBaseline = "top";

        exportNotes.forEach((note) => {
          const centerX = note.x * canvas.width;
          const centerY = note.y * canvas.height;
          const paddingX = Math.round(canvas.width * 0.008);
          const paddingY = Math.round(canvas.height * 0.006);
          const textWidth = ctx.measureText(note.text).width;
          const boxHeight = Math.round(canvas.height * 0.026);
          const boxWidth = textWidth + paddingX * 2;
          const x = centerX - boxWidth / 2;
          const y = centerY - boxHeight / 2;

          ctx.fillStyle = "rgba(10, 10, 10, 0.86)";
          ctx.fillRect(x, y, boxWidth, boxHeight);
          ctx.strokeStyle = "#a51e24";
          ctx.lineWidth = 2;
          ctx.strokeRect(x, y, boxWidth, boxHeight);
          ctx.fillStyle = "#f3f0ea";
          ctx.fillText(note.text, x + paddingX, y + paddingY);
        });
      }

      const finalizeExport = (url) => {
        const filename = `${currentProduct}-setup-sheet-annotated.png`;
        setExportState(url, filename);
        setEditorStatus(
          notes.length
            ? "Annotated PNG is ready below. Open the generated preview to save it."
            : "Annotated PNG is ready below. Your draft note was exported at a default position."
        );
      };

      try {
        const dataUrl = canvas.toDataURL("image/png");
        finalizeExport(dataUrl);
      } catch (error) {
        setEditorStatus("Export failed. Try again.");
        if (exportCopy) {
          exportCopy.textContent = "Export failed in the current browser context.";
        }
        if (exportOpen) {
          exportOpen.hidden = true;
          exportOpen.removeAttribute("href");
          exportOpen.removeAttribute("download");
        }
        if (exportPreview) {
          exportPreview.removeAttribute("src");
        }
      }
    });
  }

  const params = new URLSearchParams(window.location.search);
  const initialProduct = aliases[(params.get("product") || "").toLowerCase()] || "1178";
  applySheet(initialProduct);

  window.addEventListener("beforeunload", () => {
    revokeLastExportUrl();
  });
}

function initHotspots() {
  const groups = document.querySelectorAll("[data-hotspot-group]");

  groups.forEach((group) => {
    const triggers = group.querySelectorAll("[data-hotspot-target]");
    const panels = group.querySelectorAll("[data-hotspot-panel]");
    const image = group.querySelector("[data-hotspot-image]");
    const wrap = group.querySelector("[data-hotspot-image-wrap]");
    const stage = group.querySelector(".hotspot-stage");

    const syncFixedCanvas = () => {
      if (!image || !wrap || !stage || !image.naturalWidth || !image.naturalHeight) {
        return;
      }

      const stageWidth = stage.clientWidth - 56;
      const naturalWidth = image.naturalWidth;
      const naturalHeight = image.naturalHeight;
      const scale = Math.min(1, stageWidth / naturalWidth);
      const scaledWidth = naturalWidth * scale;
      const scaledHeight = naturalHeight * scale;

      wrap.style.width = `${scaledWidth}px`;
      wrap.style.height = `${scaledHeight}px`;
      wrap.dataset.scale = String(scale);

      triggers.forEach((trigger) => {
        const baseX = parseFloat(trigger.dataset.baseX || "0");
        const baseY = parseFloat(trigger.dataset.baseY || "0");
        trigger.style.left = `${baseX * scale}px`;
        trigger.style.top = `${baseY * scale}px`;
      });
    };

    const activate = (target) => {
      triggers.forEach((trigger) => {
        trigger.classList.toggle(
          "is-active",
          trigger.getAttribute("data-hotspot-target") === target
        );
      });

      panels.forEach((panel) => {
        panel.classList.toggle(
          "is-active",
          panel.getAttribute("data-hotspot-panel") === target
        );
      });
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        activate(trigger.getAttribute("data-hotspot-target"));
      });
    });

    if (image) {
      if (image.complete) {
        syncFixedCanvas();
      } else {
        image.addEventListener("load", syncFixedCanvas);
      }
      window.addEventListener("resize", syncFixedCanvas);
    }
  });
}

function initHotspotDebug() {
  return;
}

function initProductSwitch() {
  const switcher = document.querySelector("[data-product-switch]");
  if (!switcher) {
    return;
  }

  const buttons = switcher.querySelectorAll("[data-product-filter]");
  const panels = document.querySelectorAll("[data-product-panel]");

  const activate = (target) => {
    buttons.forEach((button) => {
      button.classList.toggle(
        "active",
        button.getAttribute("data-product-filter") === target
      );
    });

    panels.forEach((panel) => {
      panel.classList.toggle(
        "is-active",
        panel.getAttribute("data-product-panel") === target
      );
    });
  };

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      activate(button.getAttribute("data-product-filter"));
    });
  });
}

function initFaqAccordions() {
  const accordions = document.querySelectorAll("[data-faq-accordion]");
  accordions.forEach((accordion) => {
    const items = accordion.querySelectorAll(".faq-item");
    items.forEach((item) => {
      item.addEventListener("toggle", () => {
        if (!item.open) {
          return;
        }
        items.forEach((other) => {
          if (other !== item) {
            other.open = false;
          }
        });
      });
    });
  });
}

function initRevealAnimations() {
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  const targets = document.querySelectorAll(
    ".hero-copy, .hero-panel, .page-shell, .product-card, .info-card, .support-card, .resource-card, .application-card, .faq-item, .download-row, .download-library-shell, .sheet-preview-card, .sheet-sidecard"
  );

  if (!targets.length) {
    return;
  }

  document.body.classList.add("motion-ready");

  targets.forEach((node, index) => {
    node.style.setProperty("--reveal-delay", `${Math.min(index % 6, 5) * 45}ms`);
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.12,
      rootMargin: "0px 0px -8% 0px"
    }
  );

  targets.forEach((node) => observer.observe(node));
}

initSetupSheets();
initHotspots();
initHotspotDebug();
initProductSwitch();
initFaqAccordions();
initRevealAnimations();
